import { TTagsManager } from '../types/tag';
import { agentCallsForbiddenTagManager } from './agentCallsForbidden';
import { apartmentTagManager } from './apartment';
import { balconyTagManager } from './balcony';
import { builderTagManager } from './builder';
import { ceilingHeightTagManager } from './ceilingHeight';
import { commissionTypeTagManager } from './commissionType';
import { decorationsListTagsManager } from './decorationsList';
import { demolishedInMoscowProgramTagManager } from './demolishedInMoscowProgram';
import { developerTagManager } from './developer';
import { domrfTagManager } from './domrf';
import { electronicTradingTypeTagManager } from './electronicTradingType';
import { elevatorsHasServiceTagManager } from './elevatorsHasService';
import { elevatorsMinCountTagManager } from './elevatorsMinCount';
import {
  bathFacilityTagManager,
  conditionerFacilityTagManager,
  dishWasherFacilityTagManager,
  fridgeFacilityTagManager,
  garageFacilityTagManager,
  internetFacilityTagManager,
  kidsAllowedFacilityTagManager,
  kitchenFurnitureFacilityTagManager,
  petsAllowedFacilityTagManager,
  phoneFacilityTagManager,
  saunaFacilityTagManager,
  securityFacilityTagManager,
  showerFacilityTagManager,
  tvFacilityTagManager,
  washerFacilityTagManager,
} from './facilities';
import { flatShareTagManager } from './flatShare';
import { floorTagManager } from './floor';
import { fromMKADTagManager } from './fromMKAD';
import { furnitureTagManager } from './furniture';
import { garageKindTagsManager } from './garageKinds';
import { garageMaterialTagsManager } from './garageMaterials';
import { garageStatusTagsManager } from './garageStatuses';
import { garageTypeTagsManager } from './garageTypes';
import { geoBboxTagManager } from './geoBbox';
import { geoCircleTagsManager } from './geoCircles';
import { geoDistrictTagsManager } from './geoDistricts';
import { geoHighwayTagsManager } from './geoHighways';
import { geoHouseTagsManager } from './geoHouses';
import { geoLocationTagsManager } from './geoLocations';
import { geoNewbuildingTagsManager } from './geoNewbuildings';
import { geoPolygonsTagsManager } from './geoPolygons';
import { geoRailwayTagsManager } from './geoRailways';
import { geoRegionalDistrictTagsManager } from './geoRegionalDistricts';
import { geoStreetTagsManager } from './geoStreets';
import { geoUndergroundTagsManager } from './geoUndergrounds';
import { hasElectricityTagManager } from './hasElectricity';
import { hasExtinguishingSystemTagManager } from './hasExtinguishingSystem';
import { hasFlatTourBookingTagManager } from './hasFlatTourBooking';
import { hasHeatingTagManager } from './hasHeating';
import { hasProfitbaseBookingTagManager } from './hasProfitbaseBooking';
import { hasVideoTagManager } from './hasVideo';
import { heatingTypeTagsManager } from './heatingTypes';
import { hiddenBaseTagManager } from './hiddenBase';
import { houseMaterialTagsManager } from './houseMaterial';
import { houseYearTagManager } from './houseYear';
import { identicalOffersIdTagManager } from './identicalOffersId';
import { includeNewMoscowTagManager } from './includeNewMoscow';
import { isByHomeOwnerTagManager } from './isByHomeOwner';
import { isFirstFloorTagManager } from './isFirstFloor';
import { kitchenAreaTagManager } from './kitchenArea';
import { kitchenStoveTagManager } from './kitchenStove';
import { kpIdTagManager } from './kpId';
import { landAreaTagManager } from './landArea';
import { landStatusTagsManager } from './landStatuses';
import { layoutTypeTagManager } from './layoutType';
import { livingAreaTagManager } from './livingArea';
import { loggiaTagManager } from './loggia';
import { maxPrepayTagManager } from './maxPrepay';
import { mortgagePossibleTagManager } from './mortgagePossible';
import { multiIdTagManager } from './multiId';
import { newbuildingCompletedTagManager } from './newbuildingCompleted';
import { newbuildingCompletionYearTagsManager } from './newbuildingCompletionYear';
import { newbuildingDoneYearGteTagManager } from './newbuildingDoneYearGte';
import { notLastFloorTagManager } from './notLastFloor';
import { offerIdTagManager } from './offerId';
import { offerSellerTypeTagsManager } from './offerSellerTypes';
import { parkingTypeTagsManager } from './parkingTypes';
import { phoneTagManager } from './phone';
import { possessorTagManager } from './possessor';
import { promoSearchTypeTagsManager } from './promoSearchTypes';
import { publishPeriodTagManager } from './publishPeriod';
import { rentCommissionTagManager } from './rentCommission';
import { rentTimeTagManager } from './rentTime';
import { repairTagsManager } from './repair';
import { roomAreaTagManager } from './roomArea';
import { roomsInDealTagManager } from './roomsInDeal';
import { roomsTotalTagsManager } from './roomsTotal';
import { saleTypeTagsManager } from './saleTypes';
import { subsidizedMortgageTagManager } from './subsidizedMortgage';
import { suburbanHouseTypeTagManager } from './suburbanHouseType';
import {
  drainageSuburbanUtilityTagManager,
  electricitySuburbanUtilityTagManager,
  gasSuburbanUtilityTagManager,
  waterSuburbanUtilityTagManager,
} from './suburbanUtility';
import { suburbanWcTagManager } from './suburbanWc';
import { tenantTagsManager } from './tenants';
import { totalAreaTagManager } from './totalArea';
import { totalBedroomsTagManager } from './totalBedrooms';
import { totalFloorsTagManager } from './totalFloors';
import { tour3dTagManager } from './tour3d';
import { undergroundTimeTagManager } from './undergroundTime';
import { userIdTagManager } from './userId';
import { wcCountTagManager } from './wcCount';
import { wcTypeTagManager } from './wcType';
import { windowsTypeTagManager } from './windowsType';
import { withLayoutTagManager } from './withLayout';
import { withNeighborsTagManager } from './withNeighbors';
import { withoutDepositTagManager } from './withoutDeposit';
import { withPhotoTagManager } from './withPhoto';
import { wordsExcludeTagsManager } from './wordsExclude';
import { wordsIncludeTagsManager } from './wordsInclude';
import { hasRampTagManager } from './hasRamp';
import { wheelchairAccessibleTagManager } from './wheelchairAccessible';

export const tagsManagers: TTagsManager[] = [
  apartmentTagManager,
  bathFacilityTagManager,
  conditionerFacilityTagManager,
  dishWasherFacilityTagManager,
  fridgeFacilityTagManager,
  garageFacilityTagManager,
  internetFacilityTagManager,
  kidsAllowedFacilityTagManager,
  kitchenFurnitureFacilityTagManager,
  petsAllowedFacilityTagManager,
  phoneFacilityTagManager,
  saunaFacilityTagManager,
  securityFacilityTagManager,
  showerFacilityTagManager,
  tvFacilityTagManager,
  washerFacilityTagManager,
  drainageSuburbanUtilityTagManager,
  electricitySuburbanUtilityTagManager,
  gasSuburbanUtilityTagManager,
  waterSuburbanUtilityTagManager,
  tour3dTagManager,
  agentCallsForbiddenTagManager,
  flatShareTagManager,
  balconyTagManager,
  newbuildingDoneYearGteTagManager,
  ceilingHeightTagManager,
  commissionTypeTagManager,
  decorationsListTagsManager,
  demolishedInMoscowProgramTagManager,
  developerTagManager,
  domrfTagManager,
  elevatorsHasServiceTagManager,
  elevatorsMinCountTagManager,
  floorTagManager,
  furnitureTagManager,
  garageKindTagsManager,
  garageMaterialTagsManager,
  garageStatusTagsManager,
  garageTypeTagsManager,
  geoCircleTagsManager,
  geoDistrictTagsManager,
  geoHouseTagsManager,
  geoHighwayTagsManager,
  geoLocationTagsManager,
  geoNewbuildingTagsManager,
  geoPolygonsTagsManager,
  geoBboxTagManager,
  geoStreetTagsManager,
  geoUndergroundTagsManager,
  geoRailwayTagsManager,
  geoRegionalDistrictTagsManager,
  hasElectricityTagManager,
  hasExtinguishingSystemTagManager,
  hasFlatTourBookingTagManager,
  hasHeatingTagManager,
  hasProfitbaseBookingTagManager,
  hasVideoTagManager,
  heatingTypeTagsManager,
  hiddenBaseTagManager,
  houseMaterialTagsManager,
  houseYearTagManager,
  includeNewMoscowTagManager,
  isByHomeOwnerTagManager,
  isFirstFloorTagManager,
  kitchenAreaTagManager,
  kpIdTagManager,
  landStatusTagsManager,
  layoutTypeTagManager,
  livingAreaTagManager,
  loggiaTagManager,
  maxPrepayTagManager,
  mortgagePossibleTagManager,
  multiIdTagManager,
  newbuildingCompletedTagManager,
  newbuildingCompletionYearTagsManager,
  notLastFloorTagManager,
  offerIdTagManager,
  parkingTypeTagsManager,
  phoneTagManager,
  publishPeriodTagManager,
  rentTimeTagManager,
  repairTagsManager,
  roomAreaTagManager,
  roomsInDealTagManager,
  roomsTotalTagsManager,
  saleTypeTagsManager,
  suburbanWcTagManager,
  suburbanHouseTypeTagManager,
  tenantTagsManager,
  totalFloorsTagManager,
  userIdTagManager,
  wcCountTagManager,
  wcTypeTagManager,
  windowsTypeTagManager,
  withPhotoTagManager,
  withLayoutTagManager,
  withoutDepositTagManager,
  wordsExcludeTagsManager,
  wordsIncludeTagsManager,
  identicalOffersIdTagManager,
  totalBedroomsTagManager,
  possessorTagManager,
  electronicTradingTypeTagManager,
  offerSellerTypeTagsManager,
  undergroundTimeTagManager,
  builderTagManager,
  promoSearchTypeTagsManager,
  kitchenStoveTagManager,
  totalAreaTagManager,
  landAreaTagManager,
  fromMKADTagManager,
  subsidizedMortgageTagManager,
  withNeighborsTagManager,
  rentCommissionTagManager,
  hasRampTagManager,
  wheelchairAccessibleTagManager,
];
